import React from 'react'
import styles from './SpinnerPage.module.scss'

function SpinnerPage() {
  return (
    <div className={styles.SpinnerPage}>
      <img src='/images/logo-animated.gif' />
    </div>
  )
}

export default SpinnerPage